/* @flow */

//----------------------------------------------------------------------//
// Imported NPM modules
//----------------------------------------------------------------------//

import * as React from 'react';

//----------------------------------------------------------------------//
// COMPONENTS
//----------------------------------------------------------------------//

import DataTable from '../DataTable/DataTable';
import UserRole from '../UserRole/UserRole';
import AccountSummary from '../AccountSummary/AccountSummary';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

export default class ReviewData extends React.Component<*> {
  renderData(key, value, isCurrent, template, t) {
    switch (key) {
      case 'end_date':
        return <DataTable key={key} data={value} />;
      case 'user_details':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:users.labels.details')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'trading_account_access':
        if ('total_account' in value && value.total_account <= 0) {
          return null;
        }

        return (
          <React.Fragment key={key}>
            <h3>{t('general:trading_accounts.labels.access')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'temporary_product_details':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:products.labels.temporary_details')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'temporary_manufacturer_details':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:manufacturers.labels.temporary_details')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'asset_custodian':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:assets.labels.custodian')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'asset_location':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:assets.labels.location')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'asset_details':
        return <React.Fragment key={key}>{/*<h3>Asset Details</h3>*/}</React.Fragment>;
      case 'location':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:location')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'calibration_details':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:calibrations.labels.details')}</h3>
            <DataTable data={value} template={template} />
          </React.Fragment>
        );
      case 'project':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:project')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'project_details':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:projects.labels.details')}</h3>
            <DataTable data={value} />
          </React.Fragment>
        );
      case 'new_user_role':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:roles.labels.new_user_role')}</h3>
            <p>{t('general:roles.messages.role_will_change')}</p>
            <UserRole current={value} showDescription={true} />
          </React.Fragment>
        );
      case 'role_level':
      case 'user_role_name':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:roles.labels.role_level')}</h3>
            {isCurrent ? (
              <p>{t('general:roles.messages.current_role')}</p>
            ) : (
              <p>{t('general:roles.messages.current_role_will_change')}</p>
            )}
            <UserRole current={value.role_id || value} showDescription={!isCurrent} />
          </React.Fragment>
        );
      case 'account_summary':
        return (
          <React.Fragment key={key}>
            <h3>{t('general:trading_accounts:labels.summary')}</h3>
            <p>{t('general:trading_accounts:messages.gain_access')}</p>
            <AccountSummary data={value} />
          </React.Fragment>
        );
      default:
        return null;
    }
  }

  render() {
    const { data, template, isCurrent, t } = this.props;

    return Object.keys(data).map((key: string) => {
      return this.renderData(key, data[key], isCurrent, template, t);
    });
  }
}
